module.exports = __webpack_public_path__ + "assets/fbfc8a7044e0c720f648ee8c6c019bb1.png";